import React from "react";
import './Contact.css';
import siteConfig from '../../resources/data/config.js';

const isDesktop = window.matchMedia(
    "(hover: hover) and (pointer: fine)"
  ).matches;

function Contact() {
  return (
    <div className="contact">
      <h1>Get in Touch</h1>
      <div className="contact-info">
        <ContactLink
          cln={"contact-email"}
          text={"Email Us"}
          toCopy={`${siteConfig.contactEmail}`}
          action={"mailto"}
        />
        <ContactLink
          cln={"contact-phone"}
          text="Call or Text"
          toCopy={`${siteConfig.contactPhone}`}
          action="sms"
        />
      </div>
      <div className="contact-more-info">
        <p>Email, Text, or Call for consultations, appointments, or inquiries. Text to sign up for seasonal specials</p>
      </div>
    </div>
  );
}

function ContactLink({text, toCopy, action, cln}) {
  const [copied, setCopied] = React.useState(false);
  var timeoutId = null;

  function resetCopied() {
    setCopied(false);
  }

  function handleClick(toCopy, action){
    if (isDesktop) {
      navigator.clipboard.writeText(toCopy);
      setCopied(true);
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => resetCopied(false), 1500);
    }
    else {
      window.location = `${action}:${toCopy}`;
    }
  };
  return (
  <button type="button" className={`contact-button ${cln} ${copied ? 'copied' : ""}`} onClick={() => handleClick(toCopy, action)}>
    {copied ? 'Copied to clipboard!' : text}
    <p className="contact-subtext">{toCopy}</p>
  </button> 
  );
}

export default Contact;